/**
 * Thin wrapper around react-hot-toast for consistent notification usage.
 * Use these helpers instead of calling toast directly.
 */
import toast from "react-hot-toast";

export const notifications = {
	success: (message: string) => toast.success(message),
	error: (message: string) => toast.error(message),
	loading: (message: string) => toast.loading(message),
	dismiss: (id?: string) => toast.dismiss(id),
	promise: <T>(
		promise: Promise<T>,
		options: {
			loading: string;
			success: string | ((data: T) => string);
			error: string | ((err: unknown) => string);
		},
	) => toast.promise(promise, options),
};
